import { BeerFormState } from "./types";
import { User, SalesRep } from "./types";

export const defaultBeerFormState: BeerFormState = {
  beerName: "",
  quantity: "",
  abv: "",
  description: "",
  price: "",
  basePrice: 0,
  ed: 0,
  ibu: "",
  fileUpload: [],
};

export const defaultUserData: User = {
  firstName: "",
  lastName: "",
  email: "",
};

export const defaultSalesRepData: SalesRep = {
  firstName: "",
  lastName: "",
  email: "",
};
